import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "./core/helpers/auth/auth-guard.helper";

const appRoutes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },
  {
    path: "login",
    runGuardsAndResolvers: "always",
    canActivate: [AuthGuardService],
    loadChildren: "app/components/login/login.module#LoginModule",
  },
  {
    path: "recover-password",
    runGuardsAndResolvers: "always",
    canActivate: [AuthGuardService],
    loadChildren:
      "app/components/recover-password/recover-password.module#RecoverPasswordModule",
  },
  {
    path: "reset-password",
    runGuardsAndResolvers: "always",
    canActivate: [AuthGuardService],
    loadChildren:
      "app/components/reset-password/reset-password.module#ResetPasswordModule",
  },
  {
    path: "home",
    runGuardsAndResolvers: "always",
    canActivate: [AuthGuardService],
    loadChildren: "app/components/home/home.module#HomeModule",
  },
  {
    path: "admin",
    runGuardsAndResolvers: "always",
    canActivate: [AuthGuardService],
    loadChildren: "app/components/admin/admin.module#AdminModule",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { enableTracing: false })],
  exports: [RouterModule],
  providers: [AuthGuardService],
})
export class AppRoutingModules {}



// WEBPACK FOOTER //
// ./src/app/app-routing.modules.ts